import { Widget } from "@foretagsplatsen/widgetjs";
import sectionWidget from "../../../core/widgets/sectionWidget.js";

/**
 * `PeriodReportSectionWidget` renders a section in a period report
 * viewer or editor. The exact content of the widget is given by the
 * `PeriodReportSectionWidgetVisitor`.
 *
 * @param {AbstractPeriodReportSection} spec.section - The period
 * report section to render.
 * @param {Renderable} spec.content - This renderable represents the
 * main content of the receiver.
 * @param {Renderable} spec.comment - This renderable represents a
 * comment (either a viewer or an editor) to display after the
 * content.
 * @param {string} spec.dataTestName - A string to be used to find
 * the section with the test framework.
 * @param {string} spec.dataHelpName - String used by the help system
 * to find the section
 */
export default class PeriodReportSectionWidget extends Widget {
	constructor({ section, content, comment, dataTestName, dataHelpName }) {
		super(...arguments);

		this._section = section;
		this._content = content;
		this._comment = comment;

		this._sectionWidget = sectionWidget({
			title: this._titleRenderer(),
			content: [this._content, this._commentRenderer()],
			dataTestName,
			dataHelpName,
		});
	}

	renderContentOn(html) {
		html.render(this._sectionWidget);
	}

	updateCommentAndMakeVisible(comment) {
		this._comment.insertComment(comment);

		const scrollToElement = document.getElementById(this._commentId());

		scrollToElement.scrollIntoView({
			behavior: "smooth",
			block: "end",
			inline: "nearest",
		});
	}

	_titleRenderer() {
		return (html) =>
			html.span(
				{ klass: this._section.getIcon() },
				this._section.getTitle(),
			);
	}

	_commentRenderer() {
		return (html) => html.div({ id: this._commentId() }, this._comment);
	}

	_commentId() {
		return `period-report-section-${this._section.getId()}`;
	}
}
